import { c as _c } from "react/compiler-runtime";
import SlugifiedAuthorLink from "@/components/author/slugifiedAuthorLink";
import AuthorCardImage from "@/components/author/author-card/author-card-image";
import AuthorCardName from "@/components/author/author-card/author-card-name";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
export interface AuthorCardProps {
  label: string;
  name: string;
  id?: string;
  className?: string;
  image?: SanityImageSource;
  isLink?: boolean;
  role?: string;
}
const AuthorCard = props => {
  const $ = _c(21);
  const {
    id,
    label,
    name,
    role,
    image,
    isLink: t0,
    className: t1
  } = props;
  const isLink = t0 === undefined ? true : t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `flex items-center gap-2 ${className}`;
  let t3;
  if ($[0] !== id || $[1] !== image || $[2] !== isLink || $[3] !== name) {
    t3 = isLink ? <SlugifiedAuthorLink name={name ?? ""} id={id ?? ""} className="shrink-0"><AuthorCardImage name={name} image={image} /></SlugifiedAuthorLink> : <AuthorCardImage name={name} image={image} />;
    $[0] = id;
    $[1] = image;
    $[2] = isLink;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== label) {
    t4 = <span className="font-semibold uppercase">{label}</span>;
    $[5] = label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== id || $[8] !== isLink || $[9] !== name) {
    t5 = isLink ? <SlugifiedAuthorLink name={name ?? ""} id={id ?? ""}><AuthorCardName name={name} /></SlugifiedAuthorLink> : <AuthorCardName name={name} />;
    $[7] = id;
    $[8] = isLink;
    $[9] = name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== role) {
    t6 = role && <span className="text-sm font-medium">{role}</span>;
    $[11] = role;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex flex-col items-start justify-center text-[11px] text-[#858585]">{t4}{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t7) {
    t8 = <><div className={t2}>{t3}{t7}</div></>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default AuthorCard;